import { AppDataState } from './app-data-store';
import { GetUserTerritory } from './interface/get-user-territory';

export const SET_USER_TERRITORY = 'SET_USER_TERRITORY';

export type SetGetUserTerritoryAction = {
  type: typeof SET_USER_TERRITORY;
  payload: GetUserTerritory[];
};

// redux update store action
export const setGetUserTerritoryAction = (
  payload: GetUserTerritory[]
): SetGetUserTerritoryAction => {
  return {
    type: SET_USER_TERRITORY,
    payload,
  };
};

// redux reducer handler - state updater
export const setUsageDetailHandler = (
  state: AppDataState,
  action: SetGetUserTerritoryAction
): AppDataState => {
  return {
    ...state,
    getUserTerritory: action.payload,
  };
};
